import { observable } from 'mobx';

export type PrefectureResponseArgs = {
  id: number;
  name: string;
  region_name?: string;
};

export type PrefectureArgs = {
  id: number;
  name: string;
  regionName?: string;
};

export const convertPrefectureResponseToArgs = (response: PrefectureResponseArgs) => {
  const args: PrefectureArgs = {
    id: response.id,
    name: response.name,
    regionName: response.region_name
  };
  return args;
};

export default class Prefecture {
  @observable id: number;
  @observable name: string;
  @observable regionName?: string;

  constructor(args: PrefectureArgs) {
    this.id = args.id;
    this.name = args.name;
    this.regionName = args.regionName;
  }
}
